import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GuidService {
    private guid: string | null = null;

    setGuid(guid: string): void {
        this.guid = guid;
    }

    getGuid(): string | null {
        return this.guid;
    }
}
